module.exports = __webpack_public_path__ + "static/media/avatar-me-croped.d6bdff64.jpg";